var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-link-create',{attrs:{"client-id":null,"back-route":{ name: 'system-content-links' }}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/content/links/create.vue?vue&type=template&id=6b943620
// module id = FH5o
// module chunks = 0